import { Control, FilterType } from '../../../../types/types';

// Effective rendered control type for a form field, exposed on the field wrapper
// via data-form-field-type. A bare `boolean` field renders as a checkbox.
export const getFormFieldControlType = (
  control?: Control,
  type?: FilterType
): string | undefined => {
  if (control?.type) {
    return control.type;
  }

  if (type === 'boolean') {
    return 'checkbox';
  }

  return undefined;
};
